import * as React from "react";

import { Button } from "kanopi-components/Button";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

interface IButtonRhetorical {
  id: string;
  label: string;
}

export function ButtonRhetorical(props: IButtonRhetorical) {
  const { label, ...restProps } = props;
  return (
    <WidthContainer>
      <Button
        kind={Button.KIND.primary}
        shape={Button.SHAPE.pill}
        size={Button.SIZE.mini}
        {...restProps}
      >
        {label}
      </Button>
    </WidthContainer>
  );
}
